export default __webpack_public_path__ + "static/media/proximanova-extrabold.79686030.WOFF";